import React, { Fragment, useContext, useEffect, useState } from "react";
import { Alert, Button, Form } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { Dropdown } from "semantic-ui-react";
import { BasicContext } from "../../App";
import { postMethod } from "../../requests";
import AddInstructorModal from "../modals/AddInstructorModal";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faWarning } from "@fortawesome/free-solid-svg-icons";

const InstructorsDropdown = (props) => {
    const { onChange, value, req, id, disabled, label, allowAddNewInstr, small, classN, helper, clearable } = props;
    const { t } = useTranslation();
    const { checkServerData } = useContext(BasicContext);
    const [list, setList] = useState(null);
    const [loading, setLoading] = useState(true);
    const [showAddInstructorModal, setShowAddInstructorModal] = useState(false);

    const getInstructors = async () => {
        const res = await postMethod("/instructors-list");
        if (checkServerData(res)) setList(res.data.list);
    };

    useEffect(() => {
        if (list) setLoading(false);
        // eslint-disable-next-line
    }, [list]);

    useEffect(() => {
        getInstructors();
        // eslint-disable-next-line
    }, []);

    return (
        <Fragment>
            <Form.Group className={classN ? classN : "mb-3"}>
                {label && (
                    <Form.Label>
                        {t(`users.instructor`)} {req && <span className="text-danger">*</span>}
                    </Form.Label>
                )}
                {helper && <p className="text-small mb-2">{t("classes.instructorHelper")}</p>}
                {loading ? (
                    <p>{t("loadingData")}</p>
                ) : list.length === 0 && allowAddNewInstr ? (
                    <>
                        <Alert className="alert-small" variant="warning">
                            <FontAwesomeIcon icon={faWarning} className="me-2" />
                            {t("warning.noInstructors")}
                        </Alert>
                        <Button size="sm" variant="outline-secondary" className="d-block my-2" onClick={() => setShowAddInstructorModal(true)}>
                            {t("users.addNewInstructor")}
                        </Button>
                    </>
                ) : (
                    <Dropdown
                        placeholder={t("choose")}
                        fluid
                        selection
                        options={list}
                        onChange={(e, data) => onChange(data.value)}
                        value={value}
                        id={id}
                        disabled={disabled}
                        className={small && "form-control-sm"}
                        clearable={clearable}
                    />
                )}
            </Form.Group>
            {showAddInstructorModal && (
                <AddInstructorModal
                    onClose={() => setShowAddInstructorModal(false)}
                    onProceed={() => {
                        setShowAddInstructorModal(false);
                        setLoading(true);
                        getInstructors();
                    }}
                />
            )}
        </Fragment>
    );
};

export default InstructorsDropdown;
